var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-button',{staticClass:"md-accent",on:{"click":_vm.showResellerUsers}},[_vm._v(" "+_vm._s(_vm.$t('labels.manageResellerUsers'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }